import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'gatsby';
import { Button, Icon, List } from '@pella/sash-framework';
import { isValidArray } from '../../../utilities/validations';
import { formatPhoneNumber } from '../../../utilities/functions';
import { useShowroomUrls } from '../../../../hooks/use-showroom-urls';

const LocationList = ({ data, selectedPlace }) => {
	const { newShowrooms } = useShowroomUrls();
	const [listLimit, setListLimit] = useState(3);

	const onShowMoreClick = () => setListLimit((prev) => prev + 3);

	if (!isValidArray(data)) return null;

	return (
		<List
			id='js-showroomsList'
			bullets='none'
			className='space-y-2 md:pb-8'
			data-testid='location-list'
		>
			{data.map((store, index) => {
				const url = newShowrooms.nodes.find((showroom) => showroom.showroom_id === store.store_number)?.url || `/where-to-buy/showrooms/${store.page}/`;
				const showroomName = newShowrooms.nodes.find((showroom) => showroom.showroom_id === store.store_number)?.page_heading?.replace(/<\/?span[^>]*>/g, '') || store.name;
				const isActive = selectedPlace === store.line_1;

				return (
					<li
						key={index}
						data-location={showroomName}
						className={`relative ${index >= listLimit ? 'max-md:hidden' : ''}`}
					>
						<Link
							to={url}
							className={`block border bg-white px-3 py-5 text-left no-underline transition-colors ${isActive ? 'border-black shadow-[inset_0_0_0_1px_#000]' : 'border-gray-10 hover:border-gray-20'}`}
							aria-label={`Select ${showroomName}`}
						>
							<p className={`mb-2 leading-normal ${isActive ? 'font-semibold' : ''}`}>{showroomName}</p>

							<p className={`text-body-2 mb-5 mt-0 ${isActive ? 'text-black' : 'text-gray-70'}`}>
								{store.line_1}
								<br />
								{store.line_2 && store.line_2 !== 'null' && <span className='block'>{store.line_2}</span>}
								{store.city + ', ' + store.state + ' ' + store.postal_code}
								<br />
								{store.phone && formatPhoneNumber(store.phone)}
							</p>

							<p className='mt-0 inline-flex items-center gap-x-1 leading-none'>
								{isActive && (
									<span className='flex h-[18px] w-[18px] items-center justify-center rounded-full bg-primary'>
										<Icon
											name='location_on'
											size={16}
											weight={700}
										/>
									</span>
								)}

								<span className={`text-caption ${isActive ? '' : 'text-gray-60'}`}>{Math.ceil(store.dist.miles.value) + ' Miles'}</span>
							</p>
						</Link>
					</li>
				);
			})}

			{listLimit <= data.length && (
				<li className='md:hidden'>
					<Button
						color='secondary'
						size='sm'
						onClick={onShowMoreClick}
					>
						Show More
					</Button>
				</li>
			)}
		</List>
	);
};

LocationList.propTypes = {
	data: PropTypes.array,
	selectedPlace: PropTypes.string,
	onMarkerClick: PropTypes.func,
	markerRef: PropTypes.object,
};

export default LocationList;
